var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogContentText = void 0;
var DialogContentText_1 = __importDefault(require("./DialogContentText"));
exports.DialogContentText = DialogContentText_1.default;
exports.default = DialogContentText_1.default;
//# sourceMappingURL=index.js.map